import { HttpErrorResponse } from '@angular/common/http';

export class SetError {
    static readonly type = '[Error] SetError';

    constructor(public payload: HttpErrorResponse) {}
}
